import React , { useEffect,useState } from 'react';
import { Table,Spin,Input,Modal,Button,message} from 'antd';
import { APIrequest } from '../../Helpers.js'
import { ScoringSettings } from '../../MFL_ScoringSetting.js'
import { collapseTextChangeRangesAcrossMultipleVersions } from 'typescript';
// import { useReactToPrint } from 'react-to-print';
function MyLeagues (props) {
    const scoring=[
        "Passing Yards",
        "Number of Passing TDs",
        "Rushing Yards",
        "Number of Rushing TDs",
        "Receptions",
        "Receiving Yards",
        "Number of Receiving TDs"
    ]
    const scoringPositions=[
        "QB",
        "RB",
        "WR",
        "TE"
    ]
    const RuleRender= () => {
    const dict={}
    scoringPositions.forEach(pos=>{dict[pos]=PositionRuleRender(pos)})
    return dict
    }
    const getScoringCode= (desc) => {
        const temp=ScoringSettings.find(s=>s["shortDescription"]["$t"]===desc)
        return (temp["abbreviation"]["$t"])
    }
    const PositionStatRule= (pos,setting) => {
        console.log('searching',pos,setting)
        console.log('arry',rules.filter(r=>r.positions.split('|').includes(pos)))
        return(rules.filter(r=>r.positions.split('|').includes(pos))
        .map(r=>{console.log(r); 
            return ((Array.isArray(r["rule"])?
                r["rule"].find(s=>s["event"]["$t"]===setting):
                ((r["rule"]["event"]&&r["rule"]["event"]["$t"]===setting)?r["rule"]:{"points":{"$t":'0'}})
                )["points"]["$t"])})
        .reduce((pv, cv) => pv + eval(cv.replace('*', '')), 0))
    }
    const PositionRuleRender= (pos) => {
        const dict={}
        scoring.forEach(desc=> {dict[desc]=PositionStatRule(pos,getScoringCode(desc))})
        return(dict)
    }
    const [myLeagues, setMyLeagues] = useState([]);
    const [rules, setRules] = useState([]);
    const getMyLeagues = async ()=>{
        console.log("Fetching Leagues")
        const result=await APIrequest(`/api/mfl/myLeagues`)
        .then(data => {console.log(data);setMyLeagues(data.leagues.league);
        });
      }
    useEffect(()=> {
        getMyLeagues();
    } ,[]);
    const getLeagueRules = async (L)=>{
        console.log("Fetching Leagues")
        await APIrequest(`/api/mfl/getLeagueRules?L=${L}`)
        .then(data => {console.log(data.rules.positionRules);setRules(data.rules.positionRules);
        });
      }
    
    

    const SearchWordChange= e => {
        console.log("search",e.target.value);
        //setSearchWord(e.target.value)
    };
    const spinner=
    <React.Fragment>
    <Spin />
    </React.Fragment>
    
    
    console.log("rule length",rules.length)
    console.log("myLeagues",myLeagues)
    
    return (
        <div>
        <div>
            Leagues
        {myLeagues.map(league=> <div onClick={()=>getLeagueRules(league.league_id)}>{league.name}</div>)}
        </div>
        <div>
            Rules
        {JSON.stringify(RuleRender())}
        </div>
        </div>)
        
    }

    export default MyLeagues;


